export function reduceHtmlBr(html: string | undefined): string {
  if (!html) return "";
  const brRegex = /(<p><br><\/p>)+/g;
  return html.replace(brRegex, "<p><br></p>");
}
